import { gql } from '@apollo/client';
import PRODUCT_FRAGMENT from './product';
import PRODUCT_CURRICULUM_FRAGMENT from './product-curriculum';

const STUDENT_LICENSE_USAGE_FRAGMENT = gql`
  fragment BaseStudentLicenseUsage on StudentLicenseUsage {
    productId
    assignedCount
    active
    trial
    product {
      ...BaseProduct
    }
    productCurriculum {
      ...BaseProductCurriculum
    }
  }
  ${PRODUCT_FRAGMENT}
  ${PRODUCT_CURRICULUM_FRAGMENT}
`;

export default STUDENT_LICENSE_USAGE_FRAGMENT;
